import React from 'react';
import c from 'classnames';
import Image from '../../components/Image';
var Quote = function Quote(_ref) {
  var quote = _ref.quote,
    className = _ref.className,
    writer = _ref.writer,
    position = _ref.position,
    profileImage = _ref.profileImage,
    _ref$profileImageAlt = _ref.profileImageAlt,
    profileImageAlt = _ref$profileImageAlt === void 0 ? 'writer' : _ref$profileImageAlt,
    profileImageLarge = _ref.profileImageLarge,
    _ref$profileImageLarg = _ref.profileImageLargeAlt,
    profileImageLargeAlt = _ref$profileImageLarg === void 0 ? 'writer' : _ref$profileImageLarg,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'quotes' : _ref$icon,
    flipped = _ref.flipped;
  var classes = c('Quote', flipped && 'Quote--flipped', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, profileImageLarge && /*#__PURE__*/React.createElement("div", {
    className: "Quote__profileImageLarge"
  }, /*#__PURE__*/React.createElement(Image, {
    src: profileImageLarge,
    alt: profileImageAlt
  })), /*#__PURE__*/React.createElement("div", {
    className: "Quote__quotewrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "Quote__icon icon icon-".concat(icon)
  }), /*#__PURE__*/React.createElement("blockquote", {
    className: "Quote__quote"
  }, quote), writer && /*#__PURE__*/React.createElement("div", {
    className: "Quote__writer"
  }, profileImage && /*#__PURE__*/React.createElement("div", {
    className: "Quote__profileImage"
  }, /*#__PURE__*/React.createElement(Image, {
    src: profileImage,
    alt: profileImageLargeAlt
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "Quote__name large"
  }, writer), /*#__PURE__*/React.createElement("p", {
    className: "Quote__function small"
  }, position)))));
};
export default Quote;